import React from 'react';
import './SplashScreen.css';

interface SplashScreenProps {
  logo: string | null;
  onComplete: () => void;
  isDataReady?: boolean;  // 데이터 로딩 완료 여부
}

// v2 브랜드 로고(심볼+워드마크, docs/design-v2/assets/voonang-logo.png) — 스플래시 기본 이미지 (2026-09-21 배치 6).
// 정적 파일 로드 실패 시에만 관리자 업로드 로고(SiteSettings.logo) → 텍스트 순으로 폴백.
const V2_SPLASH_LOGO = '/voonang-logo.png';

const SplashScreen: React.FC<SplashScreenProps> = ({ logo, onComplete, isDataReady = false }) => {
  const [minTimeElapsed, setMinTimeElapsed] = React.useState(false);
  const [logoSrc, setLogoSrc] = React.useState<string | null>(V2_SPLASH_LOGO);

  // 최소 표시 시간 (브랜딩 목적) - 500ms
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setMinTimeElapsed(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  // 최대 대기 시간 - 2초 (데이터 로딩 실패해도 진행)
  React.useEffect(() => {
    const maxTimer = setTimeout(() => {
      onComplete();
    }, 2000);
    return () => clearTimeout(maxTimer);
  }, [onComplete]);

  // 최소 시간 + 데이터 준비 완료 시 즉시 종료
  React.useEffect(() => {
    if (minTimeElapsed && isDataReady) {
      onComplete();
    }
  }, [minTimeElapsed, isDataReady, onComplete]);

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <div className="splash-text">
          <h1 className="splash-title">새집 분양정보는 부냥에서</h1>
          <p className="splash-subtitle">분양 및 할인정보 한곳에</p>
          {!isDataReady && (
            <div className="splash-loading">
              <div className="splash-loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
        </div>
        <div className="splash-logo">
          {logoSrc ? (
            <img
              src={logoSrc}
              alt="부냥"
              className="splash-logo-image"
              onError={() => setLogoSrc(logoSrc === V2_SPLASH_LOGO && logo ? logo : null)}
            />
          ) : (
            <div className="splash-logo-text">부냥</div>
          )}
        </div>
      </div>
      <div className="splash-skip" onClick={onComplete}>
        건너뛰기
      </div>
    </div>
  );
};

export default SplashScreen;
